export const actions = {
  viewRoles: "view roles",
  editDepartments: "edit department",
  createDepartment: "create department",
};
